import { createPlugin } from '@fullcalendar/core';
import { NamedTimeZoneImpl } from '@fullcalendar/core/internal';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { JST_OFFSET, JstDate, serverTime } from './business-time';

dayjs.extend(utc);
dayjs.extend(timezone);
/** FullCalendar 6 named-zone contract. JST has no DST in this application's date range. */
class JapanTimeZone extends NamedTimeZoneImpl {
  offsetForArray(): number { return 540; }
  timestampToArray(ms: number): number[] {
    const d = new Date(ms + JST_OFFSET);
    return [d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds()];
  }
}
export const jstCalendarPlugin = createPlugin({ name: 'smft-jst', namedTimeZonedImpl: JapanTimeZone });
export function calendarNow(): Date { return new Date(serverTime.now()); }
export function businessDayjs(value?: dayjs.ConfigType): dayjs.Dayjs {
  if (value === null) return dayjs(null);
  return dayjs(value === undefined ? serverTime.now() : new JstDate(value as string | number | Date).getTime()).tz('Asia/Tokyo');
}
